import { Link } from 'react-router';

export default function ImpressumPage() {
  return (
    <main className="min-h-screen bg-warm-50 px-6 py-16 lg:px-8">
      <div className="mx-auto max-w-3xl rounded-2xl border border-warm-200/60 bg-white p-8 lg:p-10 shadow-[0_10px_28px_-16px_rgba(26,24,22,0.18)]">
        <h1 className="text-3xl font-semibold tracking-tight text-warm-800 mb-4">Impressum</h1>
        <p className="text-warm-600 leading-relaxed mb-4">MediFlow GmbH</p>
        <p className="text-warm-600 leading-relaxed mb-4">Musterstraße 1, 10115 Berlin</p>
        <p className="text-warm-600 leading-relaxed mb-6">E-Mail: kontakt@getflowly.de · Telefon: +49 30 123 456</p>
        <Link to="/" className="landing-cta-secondary">Zur Landing Page</Link>
      </div>
    </main>
  );
}
